import React, {  useState,useContext,useMemo } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { ShieldCheck } from "lucide-react";
import ToastContainer from "../../Utils/ToastContainer";
import AdminClientAssignment from "./AdminClientAssignment";
import AdminEntitlements from "./AdminEntitlements";
import AdminSubscription from "./AdminSubscriptionManagement";
import AdminAccessManagement from "./AdminAccessManagement";

const SupperAdmin = () => {
  const { userType } = useContext(GlobalContext);

 
  const isSuperAdmin =  useMemo(() => {
    try {
      const raw = sessionStorage.getItem("userData");
      const ss = raw ? JSON.parse(raw) : null;
      return ss?.adminMeta?.userType ===
"Super Admin" ? String(ss.adminMeta.userType) : "";
    } catch {
      return "";
    }
  }, []);

  const TABS = [
    { key: "client_assignment", label: "Client Assignment" },
    { key: "entitlements", label: "Entitlements" },
    { key: "subscription", label: "Subscription" },
    { key: "admin", label: "Admin Access" },
  ]

  const [activeTab, setActiveTab] = useState(TABS[0].key);

  if (!isSuperAdmin ===
"Super Admin") return null;

  return (
    <div className="space-y-4">
      {/* If ToastContainer is already used globally, you can remove this */}
      <ToastContainer />

      {/* Card Header (same as your existing style) */}
      <div className="rounded-xl border border-emerald-100 bg-gradient-to-r from-emerald-50 via-emerald-50/40 to-transparent px-4 py-3">
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div className="flex items-start gap-3">
            <div className="mt-0.5 flex h-10 w-10 items-center justify-center rounded-full bg-emerald-600 text-white shadow-sm">
              <ShieldCheck className="h-5 w-5" />
            </div>
            <div>
              <h1 className="text-base font-semibold text-gray-900 md:text-lg">
                Super Admin – Client Assignment
              </h1>
              <p className="mt-1 text-[11px] text-gray-600 md:text-xs">
                Central place to assign / unassign clients to admin users and
                manage entitlements. Visible only to{" "}
                <span className="font-semibold text-emerald-700">
                  Super Admin
                </span>
                .
              </p>
            </div>
          </div>

          <span className="inline-flex w-fit items-center rounded-full border border-emerald-100 bg-white/70 px-2.5 py-[3px] text-[10px] font-medium uppercase tracking-wide text-emerald-700">
            Super Admin Only
          </span>
        </div>

        {/* Tabs */}
        <div className="mt-3 flex flex-wrap gap-2 border-t border-emerald-100/60 pt-3">
          {TABS.map((t) => {
            const active = activeTab === t.key;
            return (
              <button
                key={t.key}
                type="button"
                onClick={() => setActiveTab(t.key)}
                className={`inline-flex items-center rounded-lg px-3 py-1.5 text-xs font-semibold shadow-sm transition ${active
                    ? "bg-emerald-600 text-white"
                    : "bg-white text-gray-700 hover:bg-emerald-50 border border-emerald-100"
                  }`}
              >
                {t.label}
              </button>
            );
          })}
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === "client_assignment" && <AdminClientAssignment />}
      {activeTab === "entitlements" && <AdminEntitlements />}
      {activeTab === "subscription" && <AdminSubscription />}
      {activeTab === "admin" && <AdminAccessManagement />}

    </div>
  );
};

export default SupperAdmin;